module.exports = __webpack_public_path__ + "static/img/图层 47.d7da4222.png";